const BirthdayEvents2026 = [
    {
        id: 1,
        birthdayImage: require("../../../Assets/Events/2026/Birthday-Celebration/BDAY-Faisal.webp"),
        birthdayName: "Faisal J Khan",
        birthdayDate: <span>07<sup>th</sup> May</span>
    },
    {
        id: 2,
        birthdayImage: require("../../../Assets/Events/2025/Birthdays-2025/BDAY-Deepak.webp"),
        birthdayName: "Deepak Baid",
        birthdayDate: <span>14<sup>th</sup> May</span>
    },
    {
        id: 3,
        birthdayImage: require("../../../Assets/Events/2026/Birthday-Celebration/BDAY-Gowthami.png"),
        birthdayName: "Gowthami N",
        birthdayDate: <span>19<sup>th</sup> May</span>
    },
    {
        id: 4,
        birthdayImage: require("../../../Assets/Events/2025/Birthdays-2025/BDAY-Punith.webp"),
        birthdayName: "Punith Raj",
        birthdayDate: <span>28<sup>th</sup> May</span>
    },
    // {
    //     id: 5,
    //     birthdayImage: require("../../../Assets/Events/2025/Birthdays-2025/BDAY-Swarnali.webp"),
    //     birthdayName: "Swarnali",
    //     birthdayDate: <span>30<sup>th</sup> July</span>
    // },
    // {
    //     id: 6,
    //     birthdayImage: require("../../../Assets/Events/2024/Birthdays-2024/BDAY-Shailaja.webp"),
    //     birthdayName: "Shailaja V B",
    //     birthdayDate: <span>12<sup>th</sup> August</span>
    // },
    // {
    //     id: 7,
    //     birthdayImage: require("../../../Assets/Events/2025/Birthdays-2025/BDAY-Renu.webp"),
    //     birthdayName: "Renu S",
    //     birthdayDate: <span>12<sup>th</sup> Sep</span>
    // },
];

export default BirthdayEvents2026;